import { Card, Dialog, DialogContent, DialogTitle, useMediaQuery, useTheme } from '@mui/material';
import type React from 'react';
import SearchButton from '../search-button';
import SearchForm from '../search-form';
import SearchResults from '../search-results';
import type { SearchHookProps } from './search-hook';

export type SearchHookOwnProps = {
  readonly open?: boolean;
};

export type SearchProps = SearchHookOwnProps & SearchHookProps;

export const Search: React.FC<SearchProps> = (props) => {
  const { open, openModal, closeModal, query, onSubmit, results, isLoading, displaySearch } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  if (!displaySearch) {
    return null;
  }

  return (
    <>
      <SearchButton onClick={openModal} />
      <Dialog fullScreen={fullScreen} maxWidth="md" open={Boolean(open)} onClose={closeModal}>
        <Card
          elevation={0}
          sx={{
            width: fullScreen ? '100%' : theme.breakpoints.values.sm,
            height: fullScreen ? '100%' : '70vh',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <DialogTitle sx={{ borderBottom: `1px solid ${theme.palette.grey[200]}` }}>
            <SearchForm query={query} onSubmit={onSubmit} />
          </DialogTitle>
          <DialogContent sx={{ overflow: 'scroll', p: 0 }} data-testid="search-results__container">
            <SearchResults query={query} results={results} isLoading={isLoading} closeModal={closeModal} />
          </DialogContent>
        </Card>
      </Dialog>
    </>
  );
};
